import { useEffect, useState } from "react";

function ProductModal({ product, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedVariant, setSelectedVariant] = useState(null);

  useEffect(() => {
    setCurrentIndex(0);
    setSelectedVariant(null);
  }, [product]);

  if (!product) return null;

  const images = product.images || [];
  const currentImage = images[currentIndex];
  const hasMultipleImages = images.length > 1;

  const goPrev = () => {
    setSelectedVariant(null);
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const goNext = () => {
    setSelectedVariant(null);
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleVariantClick = (variant) => {
    setSelectedVariant(variant);

    if (
      typeof variant.imageIndex === "number" &&
      variant.imageIndex >= 0 &&
      variant.imageIndex < images.length
    ) {
      setCurrentIndex(variant.imageIndex);
    }
  };

  return (
    <div className="image-modal" onClick={onClose}>
      <button className="modal-close" type="button" onClick={onClose}>
        ×
      </button>

      <div
        className="modal-content product-modal-content"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal-gallery">
          {currentImage ? (
            <img
              src={currentImage.src}
              alt={currentImage.alt || product.name}
              className="modal-image"
            />
          ) : (
            <div className="modal-image-placeholder">
              <span>Images coming soon</span>
            </div>
          )}

          {currentImage?.label && (
            <span className="image-label">{currentImage.label}</span>
          )}

          {hasMultipleImages && (
            <>
              <button
                className="carousel-btn carousel-btn-left"
                type="button"
                onClick={goPrev}
                aria-label="Previous image"
              >
                ‹
              </button>

              <button
                className="carousel-btn carousel-btn-right"
                type="button"
                onClick={goNext}
                aria-label="Next image"
              >
                ›
              </button>
            </>
          )}
        </div>

        <div className="modal-info product-modal-info">
          <p>{product.category}</p>
          <h3>{product.name}</h3>

          <span className="modal-price">
            {selectedVariant
              ? selectedVariant.price
              : `Starting at ${product.startingPrice}`}
          </span>

          <p className="modal-description">
            {selectedVariant ? selectedVariant.description : product.description}
          </p>

          {images.length > 1 && (
            <div className="modal-thumbnails">
              {images.map((image, index) => (
                <button
                  key={`${image.label || image.alt}-${index}`}
                  type="button"
                  className={`modal-thumb ${
                    index === currentIndex ? "active" : ""
                  }`}
                  onClick={() => {
                    setCurrentIndex(index);
                    setSelectedVariant(null);
                  }}
                  aria-label={`View ${image.label || image.alt}`}
                >
                  <img src={image.src} alt={image.alt || image.label} />
                </button>
              ))}
            </div>
          )}

          {product.variants?.length > 0 && (
            <div className="variant-list">
              <h4>Options</h4>

              {product.variants.map((variant) => (
                <button
                  type="button"
                  className={`variant-item ${
                    selectedVariant?.name === variant.name ? "active" : ""
                  }`}
                  key={variant.name}
                  onClick={() => handleVariantClick(variant)}
                >
                  <div>
                    <strong>{variant.name}</strong>
                    <span>{variant.description}</span>
                  </div>

                  <p>{variant.price}</p>
                </button>
              ))}
            </div>
          )}

          <a href="#contact" className="modal-contact-btn" onClick={onClose}>
            Ask about this product
          </a>
        </div>
      </div>
    </div>
  );
}

export default ProductModal;